import {csvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/csv", csvParse);



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-request/src/csv.js
// module id = ../../../../d3-request/src/csv.js
// module chunks = 4